import React from 'react';

import { useSpotify } from '../../../hoc/context/SpotifyContextContainer'

const Playlists = ({playlists, add}) => {
    const { user } = useSpotify()
    const items = playlists.filter(item => user.id === item.owner.id);
    return (
        <div className="player__playlists-content">
            {items.map((item, i) => (
                 <div key={i} className="player__playlist-item" onClick={() => add(item.id)}>
                    {item.name}
                </div>
            ))}
        </div>
    );
}

export default Playlists;
